"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyObject = void 0;
/**
 * The function checks if an object is empty by checking if it has no keys.
 * @param {object} obj - The parameter "obj" is of type "object", which means it can accept any
 * JavaScript object as an argument.
 */
const isEmptyObject = obj => Object.keys(obj).length === 0;
exports.isEmptyObject = isEmptyObject;
